<template>
  <div>
    <b-table
      hover
      striped
      responsive="sm"
      :fields="tableFields"
      :items="visits"
    >
      <template #cell(time)="row">
        {{ row.item.time | moment }}
      </template>
      <template #cell(location_id)="row">
        {{ row.item.location_id | clubSort }}
      </template>
      <template #cell(product)="row">
        {{ row.item | productSort }}
      </template>
      <template #cell(admin)="row">
        {{ row.item.admin.name }} {{ row.item.admin.surname }}
      </template>
    </b-table>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "VisitsTable",
  props: {
    clientId: Number,
  },
  data: function () {
    return {
      visits: [],
    };
  },
  computed: {
    tableFields() {
      return [
        { key: "time", label: "Час" },
        { key: "product", label: "Карта/Послуга" },
        { key: "location_id", label: "Клуб" },
        { key: "amount", label: "Сума" },
        { key: "admin", label: "Адмін" },
      ];
    },
  },
  async mounted() {
    await this.getVisits();
  },
  methods: {
    async getVisits() {
      let response = await this.$api.visits.getVisits(this.clientId);
      this.visits = response.data;
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YY HH:mm");
    },
    clubSort: function (club) {
      if (club === 1) {
        return "Василенко, 9";
      } else if (club === 2) {
        return "Острозького, 55";
      }
    },
    productSort: function (item) {
      if (item.group) {
        return item.group.name;
      } else if (item.card) {
        return item.card.product.name;
      } else if (item.training) {
        return item.training.name;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped></style>
